import React, { useState, useContext, useEffect } from "react";
import OrderField from "../shared/order_field";
import { useQuery } from "@tanstack/react-query";
import { OrderContext } from "../../../contexts/order_context";
import { useFormContext } from "react-hook-form";
import { getProgramHotels } from "../../../queries";
import Rooms from "./rooms";
import Meals from "./meals";

const OrderHotels = ({ term }) => {
  const { termId } = useContext(OrderContext);
  const [showHotels, setShowHotels] = useState(term.required_hotel);
  const { register, setValue, watch, getValues, field } = useFormContext({
    defaultValues: {
      term2: null,
    },
  });

  const adults = watch("adults");
  const children = watch("children");
  const term2Id = watch("term2");

  const programHotelsQuery = useQuery(["program_hotels"], () =>
    getProgramHotels({ termId, adults: adults.value, children: children.value })
  );

  useEffect(() => {
    if (getValues("show_hotels") != showHotels)
      setValue("show_hotels", showHotels);
  }, [showHotels]);

  useEffect(() => {
    if (showHotels && getValues("term2") == null)
      setValue("term2", programHotelsQuery?.data?.[0]?.id);
  }, [programHotelsQuery.data]);

  return programHotelsQuery?.data ? (
    <OrderField title={I18n.t("js.order.fields.accomodation2")}>
      <div className="order-form__block-content">
        <div className="row">
          {programHotelsQuery.data && (
            <div className="col-lg-12">
              <input
                {...field}
                id={"show_hotels"}
                type="checkbox"
                defaultChecked={term.required_hotel}
                onChange={(e) => {
                  setShowHotels(e.target.checked);
                }}
                disabled={term.required_hotel ? "disabled" : ""}
              />
              <label htmlFor="show_hotels">{I18n.t("js.order.extend")}</label>
              {showHotels && (
                <div className="hotels_wrapper">
                  {programHotelsQuery.data?.map((term) => {
                    return (
                      <div key={term.id}>
                        <input
                          type="radio"
                          id={`term2-id${term.id}`}
                          value={term.id}
                          className="hotel_radio"
                          {...field}
                          onChange={(e) => {
                            setValue("term2", e.target.value);
                          }}
                          checked={term.id == term2Id}
                        />
                        <label htmlFor={`term2-id${term.id}`}>
                          <span>
                            {term.hotel_name}{" "}
                            {I18n.t("js.order.extend_for_nights", {
                              count: parseInt(term.nights),
                              nights: term.nights,
                            })}
                          </span>
                          <span
                            className="stars"
                            dangerouslySetInnerHTML={{
                              __html: term.hotel_stars,
                            }}
                          />
                          <div className="row">
                            {term.hotel_image1_url && (
                              <div className="col-md-2">
                                <img
                                  src={term.hotel_image1_url}
                                  alt={`${term.hotel_name} ${I18n.t(
                                    "js.order.image"
                                  )} 1`}
                                  className="img-responsive margin-bottom-10"
                                />
                              </div>
                            )}
                            {term.hotel_image2_url && (
                              <div className="col-md-2">
                                <img
                                  src={term.hotel_image2_url}
                                  alt={`${term.hotel_name} ${I18n.t(
                                    "js.order.image"
                                  )} 2`}
                                  className="img-responsive margin-bottom-10"
                                />
                              </div>
                            )}
                          </div>
                        </label>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        {typeof term2Id !== "undefined" && showHotels && (
          <div className="rooms-var">
            <div className="hotels_wrapper">
              <hr />
              <div className="row">
                <div className="col-lg-6 rooms-var__item-wrap">
                  <h3>
                    <i className={`fas fa-bed`}></i>
                    {I18n.t("js.order.room_type")}
                  </h3>
                  <div className="rooms-var__item">
                    <Rooms selectedTermId={term2Id} isExtra={true} />
                  </div>
                </div>
                <div className="col-lg-6 rooms-var__item-wrap">
                  <h3>
                    <i className={`fas fa-utensils`}></i>
                    {I18n.t("js.order.meal")}
                  </h3>
                  <Meals selectedTermId={term2Id} isExtra={true} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </OrderField>
  ) : (
    <></>
  );
};

export default OrderHotels;
